<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <div class="wrapper">
        <app-header></app-header>
        <app-sidebar [page]="'dashboard'"></app-sidebar>

        <div class="content-wrapper dashboard-page">
            <section class="content dashboard-content">
                <div class="container-fluid">
                    <div class="dashboard-title-row">
                        <div>
                            <h1>Enterprise Operations Platform</h1>
                            <p>Manage your workforce, financial operations, permissions, and business workflows from one central hub.</p>
                        </div>
                    </div>

                    <div class="row dashboard-metrics">
                        <div class="col-lg-3 col-md-6">
                            <a [routerLink]="['/users']" class="metric-card metric-card-primary">
                                <span class="metric-icon"><i class="fas fa-building"></i></span>
                                <span class="metric-label">Entities</span>
                                <strong>{{ totalEntities() }}</strong>
                                <small>{{ userData?.stats?.users?.active || 0 }} active accounts</small>
                            </a>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <a [routerLink]="['/users', 'pending']" class="metric-card metric-card-warning">
                                <span class="metric-icon"><i class="fas fa-user-clock"></i></span>
                                <span class="metric-label">KYC Work Queue</span>
                                <strong>{{ totalKycWork() }}</strong>
                                <small>{{ userData?.stats?.users?.pending || 0 }} pending review</small>
                            </a>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <a [routerLink]="['/dealslip']" class="metric-card metric-card-success">
                                <span class="metric-icon"><i class="fas fa-file-invoice-dollar"></i></span>
                                <span class="metric-label">Dealslips</span>
                                <strong>{{ dealslipDashboard?.data?.totalDeals || 0 }}</strong>
                                <small>{{ dealslipDashboard?.data?.status?.complete || 0 }} completed</small>
                            </a>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="metric-card metric-card-info">
                                <span class="metric-icon"><i class="fas fa-bell"></i></span>
                                <span class="metric-label">Notifications</span>
                                <strong>{{ userData?.notification?.total || 0 }}</strong>
                                <small>{{ userData?.notification?.KYC || 0 }} KYC alerts</small>
                            </div>
                        </div>
                    </div>

                    <div class="row dashboard-metrics" *ngIf="hasHrWidgets()">
                        <div class="col-lg-3 col-md-6" *ngIf="checkService.canRead(['hr.staff', 'users'])">
                            <a [routerLink]="['/hr', 'employee-profiles-kin']" class="metric-card">
                                <span class="metric-icon"><i class="fas fa-id-badge"></i></span>
                                <span class="metric-label">Staff Profiles</span>
                                <strong>{{ hrStaffList.length }}</strong>
                                <small>{{ hrStatusCount(hrStaffList, 'suspended') }} suspended</small>
                            </a>
                        </div>
                        <div class="col-lg-3 col-md-6" *ngIf="checkService.canRead(['hr.leave', 'hr.staff', 'users'])">
                            <a [routerLink]="['/hr', 'leave-management']" class="metric-card">
                                <span class="metric-icon"><i class="fas fa-calendar-alt"></i></span>
                                <span class="metric-label">Leave Requests</span>
                                <strong>{{ hrLeaveList.length }}</strong>
                                <small>{{ hrStatusCount(hrLeaveList, 'pending') }} pending approval</small>
                            </a>
                        </div>
                        <div class="col-lg-3 col-md-6" *ngIf="checkService.canRead(['hr.department', 'hr.staff', 'users'])">
                            <a [routerLink]="['/hr', 'departments']" class="metric-card">
                                <span class="metric-icon"><i class="fas fa-sitemap"></i></span>
                                <span class="metric-label">Departments</span>
                                <strong>{{ hrDepartmentList.length }}</strong>
                                <small>{{ hrDesignationList.length }} designations</small>
                            </a>
                        </div>
                        <div class="col-lg-3 col-md-6" *ngIf="checkService.canRead(['hr.organogram', 'hr.staff', 'users'])">
                            <a [routerLink]="['/hr', 'org-chart']" class="metric-card">
                                <span class="metric-icon"><i class="fas fa-project-diagram"></i></span>
                                <span class="metric-label">Org Chart</span>
                                <strong>{{ hrOrganogramList.length }}</strong>
                                <small>{{ staffWithAdminCount() }} admin-linked staff</small>
                            </a>
                        </div>
                    </div>

                    <div class="dashboard-main-grid">
                        <section class="figma-panel analytics-panel">
                            <div class="figma-panel-header">
                                <div>
                                    <h2>Operational Analytics</h2>
                                    <p>User activity & request trends — 6 months</p>
                                </div>
                            </div>
                            <div class="analytics-chart">
                                <div class="chart-grid">
                                    <span>200</span>
                                    <span>150</span>
                                    <span>100</span>
                                    <span>50</span>
                                    <span>0</span>
                                </div>
                                <svg viewBox="0 0 720 220" preserveAspectRatio="none" aria-label="Operational analytics chart">
                                    <polyline points="0,78 140,65 280,58 420,51 560,43 720,28" class="chart-line chart-line-orange"></polyline>
                                    <polyline points="0,160 140,145 280,152 420,134 560,120 720,138" class="chart-line chart-line-deep"></polyline>
                                </svg>
                                <div class="chart-months">
                                    <span>Jan</span><span>Feb</span><span>Mar</span><span>Apr</span><span>May</span><span>Jun</span>
                                </div>
                            </div>
                        </section>

                        <section class="figma-panel">
                            <div class="figma-panel-header">
                                <h2>Recent Activity</h2>
                            </div>
                            <div class="activity-list">
                                <div class="activity-item" *ngFor="let item of recentActivities()">
                                    <span [class]="item.className">{{ item.initial }}</span>
                                    <div>
                                        <strong>{{ item.title }}</strong>
                                        <small>{{ item.subtitle }}</small>
                                    </div>
                                    <em>{{ item.time }}</em>
                                </div>
                            </div>
                        </section>
                    </div>

                    <section class="figma-panel approval-panel">
                        <div class="figma-panel-header">
                            <h2>Approval Queue</h2>
                            <a [routerLink]="['/hr', 'leave-management']" class="btn btn-default btn-sm">View All</a>
                        </div>
                        <div class="table-responsive">
                            <table class="table figma-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Request Type</th>
                                        <th>Requested By</th>
                                        <th>Department</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of approvalRows()">
                                        <td>{{ row.id }}</td>
                                        <td><strong>{{ row.type }}</strong></td>
                                        <td>{{ row.requestedBy }}</td>
                                        <td>{{ row.department }}</td>
                                        <td><span [class]="row.badgeClass">{{ row.status }}</span></td>
                                        <td>{{ row.date }}</td>
                                        <td><a [routerLink]="row.route"><i class="far fa-eye"></i> View</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section class="figma-panel holiday-panel">
                        <div class="figma-panel-header">
                            <div>
                                <h2><i class="fas fa-globe text-warning"></i> Global Holiday Calendar</h2>
                            </div>
                            <div class="calendar-month">
                                <i class="fas fa-chevron-left"></i>
                                <strong>June 2024</strong>
                                <i class="fas fa-chevron-right"></i>
                            </div>
                        </div>
                        <div class="holiday-tags">
                            <span class="tag-uk">UK</span>
                            <span class="tag-us">US</span>
                            <span class="tag-ca">Canada</span>
                            <span class="tag-ng">Nigeria</span>
                            <span class="tag-sa">South Africa</span>
                            <span class="tag-gh">Ghana</span>
                        </div>
                        <div class="calendar-grid">
                            <strong>Sun</strong><strong>Mon</strong><strong>Tue</strong><strong>Wed</strong><strong>Thu</strong><strong>Fri</strong><strong>Sat</strong>
                            <span></span><span></span><span></span><span></span><span></span><span></span><b>1</b>
                            <b>2</b><b>3</b><b>4</b><b>5</b><b>6</b><b>7</b><b>8</b>
                            <b>9</b><b>10</b><b>11</b><b class="has-dot">12</b><b>13</b><b>14</b><b>15</b>
                            <b class="has-dot">16</b><b class="has-dot">17</b><b>18</b><b class="has-red-dot">19</b><b>20</b><b>21</b><b>22</b>
                            <b>23</b><b>24</b><b>25</b><b>26</b><b class="selected-day">27</b><b>28</b><b>29</b>
                            <b>30</b>
                        </div>
                        <p class="calendar-note"><i class="far fa-clock"></i> Click dates to see holidays · Correlate with rate history to identify market patterns</p>
                    </section>
                </div>
            </section>
        </div>

        <app-footer></app-footer>
    </div>
</div>
